var _excluded = ["onPageChange", "currentPage", "totalItems", "pageSize"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { IconButton } from '../../action';
import { Box } from '../../internal';
import { getEndIndex, getNextEnabled, getPreviousEnabled, getStartIndex } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Pagination = forwardRef((_ref, ref) => {
  var {
    onPageChange,
    currentPage = 1,
    totalItems,
    pageSize
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  var styles = useMultiStyleConfig('Pagination', {});
  var startIndex = getStartIndex(pageSize, currentPage, totalItems);
  var endIndex = getEndIndex(pageSize, currentPage, totalItems);
  var isPreviousEnabled = getPreviousEnabled(currentPage);
  var isNextEnabled = getNextEnabled(currentPage, totalItems, pageSize); // Github discussion: https://github.com/melio/penny/discussions/454
  // TODO: No localization inside components library (for now)

  var paginationText = "".concat(startIndex, "-").concat(endIndex, " of ").concat(totalItems);
  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    "data-component": "Pagination"
  }, rest), {}, {
    __css: styles['container'],
    ref: ref,
    children: [/*#__PURE__*/_jsx(Box, {
      __css: styles['paginationText'],
      "data-testid": "pagination-text",
      children: paginationText
    }), /*#__PURE__*/_jsxs(Box, {
      __css: styles['buttonsContainer'],
      children: [/*#__PURE__*/_jsx(IconButton, {
        "data-testid": "chevron-left",
        icon: "chevron-left",
        "aria-label": "Previous",
        variant: "naked",
        size: "small",
        onClick: () => onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(currentPage - 1),
        isDisabled: !isPreviousEnabled
      }), /*#__PURE__*/_jsx(IconButton, {
        "data-testid": "chevron-right",
        icon: "chevron-right",
        "aria-label": "Next",
        variant: "naked",
        size: "small",
        onClick: () => onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(currentPage + 1),
        isDisabled: !isNextEnabled
      })]
    })]
  }));
});
Pagination.displayName = 'Pagination';
//# sourceMappingURL=Pagination.js.map